/**
 * PIN入力時の触覚フィードバック
 * - 振動: Vibration API（Android/Chrome 等で対応、iOS は非対応）
 */

/** 短い振動（Vibration API、対応環境のみ） */
export function vibrateShort(): void {
  try {
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
      navigator.vibrate(10);
    }
  } catch {
    // 非対応時は無視
  }
}

/** PIN入力時のフィードバック（振動のみ、音はなし） */
export function playInputFeedback(): void {
  vibrateShort();
}
